import type { StyleLayer } from './utils/types'

export const layers_roads_plus_fusswege: StyleLayer[] = [
  {
    id: 'roadclassification-nokfz',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['path', 'track', 'bridleway', 'footway', 'cycleway', 'footway_steps'],
      true,
      false,
    ],
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'road'], ['track', 'bridleway'], true, false],
        '#b4aac0',
        ['match', ['get', 'road'], ['path', 'footway', 'cycleway'], true, false],
        '#c8aad5',
        'rgba(192, 191, 191, 0.75)',
      ],
      'line-width': 0.7,
    },
  },
  {
    id: 'hitarea-roadclassification_plus_fusswege',
    type: 'line',
    filter: [
      'match',
      ['get', 'road'],
      ['path', 'track', 'bridleway', 'footway', 'cycleway', 'footway_steps'],
      true,
      false,
    ],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'road'], ['track', 'bridleway'], true, false],
        '#b4aac0',
        ['match', ['get', 'road'], ['path', 'footway', 'cycleway'], true, false],
        '#c8aad5',
        'rgba(192, 191, 191, 0.75)',
      ],
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
  {
    id: 'roads-onewaybikeyes-pattern fusswege',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'oneway_bicycle'], ['no'], true, false],
      [
        'match',
        ['get', 'road'],
        ['path', 'track', 'bridleway', 'footway', 'cycleway'],
        true,
        false,
      ],
    ],
    minzoom: 13,
    layout: {
      'line-cap': 'square',
      'line-miter-limit': 0,
    },
    paint: {
      'line-opacity': 0.8,
      'line-pattern': 'pattern-oneway-bicycle',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 3, 15, 5, 22, 10],
    },
  },
  {
    id: 'roads-oneway-pattern',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'oneway'], ['yes', 'implicit_yes'], true, false],
      [
        'match',
        ['get', 'road'],
        ['path', 'track', 'bridleway', 'footway', 'cycleway'],
        true,
        false,
      ],
    ],
    minzoom: 13,
    layout: {
      'line-cap': 'square',
    },
    paint: {
      'line-opacity': 0.7,
      'line-pattern': 'pattern-oneway',
      'line-width': ['interpolate', ['linear'], ['zoom'], 13, 3, 15, 5, 22, 10],
    },
  },
]
